<template>
  <p-container>
    <p-row column>
      <div>
        <p-row align-center>
          <p-button tertiary @click="back">
            <p-icon>
              keyboard_backspace
            </p-icon>
          </p-button>
          <h2>{{ title }}</h2>
        </p-row>
      </div>
      <p-col v-if="errorResponse">
        <p-request-alert v-model="errorResponse"></p-request-alert>
      </p-col>
      <p-card>
        <p-progress-linear v-if="isLoading" indeterminate></p-progress-linear>
        <p-row v-else column>
          <p-col>
            <p-row column dense>
              <div>Id: {{ id }}</div>
              <div>{{ $t('core.page.integrationlog.list.source') }}: {{ integrationDetail.sourceAppSystemName }}</div>
              <div>{{ $t('core.page.integrationlog.list.status') }}: {{ $tEnum('core.page.integrationlog.statusId', integrationDetail.integrationStatusId) }}</div>
              <div>{{ $t('core.page.integrationlog.list.message') }}: {{ integrationDetail.integrationStatusMessage }}</div>
              <div>{{ $t('core.page.integrationlog.created') }}: {{ $format.localDateAndTime(integrationDetail.created, 'L LTS') }} {{ $t('core.page.integrationlog.by') }} {{ integrationDetail.modifierName }}</div>
              <div>{{ $t('core.page.integrationlog.list.processed') }}: {{ $format.localDateAndTime(integrationDetail.modified, 'L LTS') }}</div>
              <div>{{ $t('core.page.integrationlog.list.runNo') }}: {{ integrationDetail.runNo }}</div>
            </p-row>
          </p-col>
        </p-row>
      </p-card>
      <p-progress-linear v-if="isLoading" indeterminate></p-progress-linear>
      <p-card v-else>
        <p-row column>
          <p-textarea v-model="integrationObjectString" rows="10" :label="$t('core.page.integrationlog.object')" required>
          </p-textarea>
          <p-text-field v-model="integrationStatusMessage" :label="$t('core.page.integrationlog.completeDialog.label')" required></p-text-field>
        </p-row>
      </p-card>
    </p-row>
    <p-row justify-end>
      <p-button @click="back()">
        {{ $t('core.app.cancel') }}
      </p-button>
      <p-button :disabled="!integrationStatusMessage || !integrationObjectString" @click="reExecuteIntegrationCall()">
        {{ $t('core.app.ok') }}
      </p-button>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import ReExecuteIntegrationCallRequestViewModel from '../../../../services/v1/viewModel/resource/ReExecuteIntegrationCallRequestViewModel';
  import IntegrationCallResourceViewModel from '../../../../services/v1/viewModel/resource/IntegrationCallResourceViewModel';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      integrationStatusMessage: (undefined as string | undefined),
      isLoading: false,
      integrationDetail: {} as IntegrationCallResourceViewModel,
      errorResponse: (undefined as string | undefined),
      list: {},
      steps: [] as any[],
      id: Number as unknown | undefined,
    }),
    computed: {
      integrationObjectString: {
        get() {
          let integrationObjectString = this.integrationDetail?.integrationObject ?? 'undefined';
          try {
            if (integrationObjectString.trim().startsWith('{')) {
              integrationObjectString = JSON.stringify(JSON.parse(integrationObjectString), undefined, 2);
            }
          } catch (e) {
            // do nothing
          }
          return integrationObjectString;
        },
        set(value: string) {
          this.integrationDetail.integrationObject = value;
        },
      },
      title() {
        return `${this.integrationDetail.integrationTaskName} (Id: ${this.integrationDetail.id}) ${this.$t('core.page.integrationlog.page.executeAgain')}` ?? this.$t('core.page.integrationlog.integrationDetailTitle');
      },
    },
    async mounted() {
      this.isLoading = true;
      try {
        const { id } = this.$router.currentRoute.params;
        this.id = id;
        const responseIntegrationLog = await this.$service.api.core.integrationCalls.getIntegrationCallById(id as any);
        this.integrationDetail = responseIntegrationLog;
        if (![3, 5].includes(this.integrationDetail.integrationStatusId!)) {
          this.back();
          return;
        }
        if (this.integrationDetail.modifierName === null || this.integrationDetail.modifierName === '') {
          this.integrationDetail.modifierName = 'None';
        }
        if (this.integrationDetail.integrationStatusMessage === null || this.integrationDetail.integrationStatusMessage === '') {
          this.integrationDetail.integrationStatusMessage = 'Success';
        }
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isLoading = false;
    },
    methods: {
      back() {
        this.$router.back();
      },
      async reExecuteIntegrationCall() {
        this.isLoading = true;
        try {
          // check if integrationObject is valid json
          JSON.parse(this.integrationDetail.integrationObject!);
          const req = new ReExecuteIntegrationCallRequestViewModel();
          req.comment = this.integrationStatusMessage!;
          req.payload = this.integrationDetail.integrationObject!;
          await this.$service.api.core.integrationCalls.reExecuteIntegrationCall(this.integrationDetail.id!, req);
          this.$router.push(`/_hostadmin/integrationlog/${this.integrationDetail.id}`);
        } catch (error: any) {
          this.errorResponse = error;
        }
        this.isLoading = false;
      },
    },
  });
</script>
<style scoped>
  .p-card {
    overflow-wrap: break-word;
  }
  td {
    white-space: normal !important;
  }
</style>
